module.exports = __webpack_public_path__ + "img/8.1766c77a.jpg";